module.exports = __webpack_public_path__ + "ui-static/img/cameras-no-items_dark.ddfd12b8.svg";